export default (object: any, key: string, value: number) => {
  if (object[key]) {
    return object[key] + value;
  }
  return value;
};
